"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opacity = void 0;
exports.opacity = {
    level: {
        0: 0,
        1: 0.04,
        2: 0.08,
        3: 0.12,
        4: 0.16,
        5: 0.24,
        6: 0.32,
        7: 0.64,
        8: 0.72
    }
};
